import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  success(config?: ToastMessageOptions) {
    this.messageService.add({
      ...config,
      severity: 'success',
      summary: this.translate.instant(config?.summary ?? 'common.success'),
      detail: this.translate.instant(config?.detail ?? 'common.action_success'),
    });
  }

  error(config?: ToastMessageOptions) {
    this.messageService.add({
      ...config,
      severity: 'error',
      summary: this.translate.instant(config?.summary ?? 'common.error'),
      detail: this.translate.instant(config?.detail ?? 'common.something_went_wrong'),
    });
  }

  warn(config?: ToastMessageOptions) {
    this.messageService.add({
      ...config,
      severity: 'warn',
      summary: this.translate.instant(config?.summary ?? 'common.warning'),
      detail: this.translate.instant(config?.detail ?? ''),
    });
  }

  info(config?: ToastMessageOptions) {
    this.messageService.add({
      ...config,
      severity: 'info',
    });
  }
}

